
import gql from 'graphql-tag';
import productPromotionFragment from '~/apollo/fragments/productPromotionFragment';
import homePlanScenariosQuery from '~/apollo/queries/product/homePlanScenario.gql';
import homeTooltips from '~/apollo/queries/product/tooltips/homeTooltips';
import commonProductDetailMixins from '~/mixins/commonProductDetailMixins.js';
import productPromotionMixins from '~/mixins/productPromotionMixins.js';
import productInsuranceNameMixins from '~/mixins/productInsuranceNameMixins';

export default {
  mixins: [commonProductDetailMixins, productPromotionMixins, productInsuranceNameMixins],

  data() {
    return {
      homePlanScenarios: null,
      loading: 0,
      propertyAge: this.$route.query.propertyAge,
      // grossArea: this.$route.query.grossArea,
      saleableArea: this.$route.query.saleableArea,
      currentLocale: this.$normalizeLocale(this.$i18n.locale),
    };
  },
  // page component definitions
  apollo: {
    $loadingKey: 'loading',
    homePlanScenarios: {
      query: gql`
        ${homePlanScenariosQuery}
        ${productPromotionFragment}
      `,
      prefetch: true,
      variables() {
        return {
          scenario_code: this.$route.params.slug,
          locale: this.currentLocale,
        };
      },
    },
    homeTooltips: {
      query: homeTooltips,
      prefetch: true,
      variables() {
        return { currentlocale: this.$normalizeLocale(this.$i18n.locale) };
      },
      update(data) {
        return this.$normalizeStrapi(data.infoTooltip.data);
      },
    },
  },
  computed: {
    simpleItems() {
      if (this.homePlanScenarios?.data[0]) {
        const decoderCTALink = '';
        let promotionPrices = Array;
        promotionPrices = [];

        const item = this.homePlanScenarios.data[0];
        let promotions = null;
        let promotion = null;
        let promotion_last_call = null;

        let CTAButtonLink;
        let CTAButtonText;
        let hide = Boolean;
        hide = false;
        let noPopup = Boolean;
        noPopup = false;
        let mainCTA = this.getDecoderCTA(this.homePlanScenarios.data[0], decoderCTALink);

        // check scenario level promo first , then plan level promotion
        if (item.attributes.product_promotions.data?.length > 0) {
          promotions = item.attributes.product_promotions.data;
        }
        if (item.attributes.home_plan.data.attributes.product_promotions.data?.length > 0) {
          promotions = item.attributes.home_plan.data.attributes.product_promotions.data;
        }

        if(promotions != null) {
          promotion = this.checkPromotionValid(promotions);
          promotion_last_call = this.checkPromotionLastCall(promotion);

          if (!promotion) {
            promotion = null;
          } else {
            const promotionCTAink = promotion.attributes.product_promotion_translations?.data[0]
              ? promotion.attributes.product_promotion_translations?.data[0]?.attributes?.CTAButtonLink
              : '';
            mainCTA = this.getDecoderCTA(this.homePlanScenarios.data[0], promotionCTAink);
            const discounts = promotion.attributes.DiscountPercentage;
            if (discounts) {
              // calculate promotion price for annual premium
              const annualPremium = item.attributes.annual_premium;

              if (discounts.Year1 === 0) {
                promotionPrices[0] = null;
              } else {
                const calculatedPrice = (annualPremium * (100 - discounts.Year1)) / 100;
                promotionPrices[0] = parseInt(calculatedPrice.toFixed(0));
              }
            }

            if (mainCTA) {
              const salesLink = mainCTA.link.includes(process.env.SALES_EXTERNAL_URL)
                ? mainCTA.link + (promotion?.id ? '&promotionId=' + promotion?.id : '')
                : mainCTA.link;
              mainCTA.link = salesLink;
              CTAButtonLink = mainCTA.link;
              CTAButtonText = mainCTA.text;
            } else {
              CTAButtonLink = promotionCTAink;
              CTAButtonText = this.$t('products.purchase_now');
            }

            const translation = promotion.attributes.product_promotion_translations?.data[0];
            hide = translation.attributes?.HideBanner;
            noPopup = translation?.attributes?.NoPopup??false;
          }
        }

        // console.log(promotions);

        const filteredTranslations = this.getFilteredTranslations(item.attributes.home_plan.data.attributes.product.data.attributes.insurance_company.data.attributes
        .insurance_company_translations.data[0].attributes.localizations.data);

        return {
          scenario_code: this.homePlanScenarios.data[0].attributes.scenario_code,
          plan_code_owner: this.homePlanScenarios.data[0].attributes.plan_code_owner,
          plan_code: this.homePlanScenarios.data[0].attributes.plan_code,
          owner: this.homePlanScenarios.data[0].attributes.owner,
          // gross_area_min: this.homePlanScenarios.data[0].attributes.gross_area_min,
          // gross_area_max: this.homePlanScenarios.data[0].attributes.gross_area_max,
          saleable_area_min: this.homePlanScenarios.data[0].attributes.saleable_area_min,
          saleable_area_max: this.homePlanScenarios.data[0].attributes.saleable_area_max,
          property_type: this.homePlanScenarios.data[0].attributes.property_type,
          multiple_property_type: this.homePlanScenarios.data[0].attributes.home_plan.data.attributes.property_type,
          building_age_min: this.homePlanScenarios.data[0].attributes.building_age_min,
          building_age_max: this.homePlanScenarios.data[0].attributes.building_age_max,
          plan_type: this.homePlanScenarios.data[0].attributes.plan_type,
          annual_premium: this.homePlanScenarios.data[0].attributes.annual_premium,
          ch1040: this.homePlanScenarios.data[0].attributes.ch1040,
          overall_score: this.homePlanScenarios.data[0].attributes.overall_score,
          home_contents_score: this.homePlanScenarios.data[0].attributes.home_contents_score,
          liability_score: this.homePlanScenarios.data[0].attributes.liability_score,
          personal_accident_score: this.homePlanScenarios.data[0].attributes.personal_accident_score,

          plan_name:
            this.homePlanScenarios.data[0].attributes.home_plan.data.attributes.home_plan_translations.data[0]
              .attributes.name,
          product_feature1:
            this.homePlanScenarios.data[0].attributes.home_plan.data.attributes.home_plan_translations.data[0]
              .attributes.product_feature1,
          product_feature2:
            this.homePlanScenarios.data[0].attributes.home_plan.data.attributes.home_plan_translations.data[0]
              .attributes.product_feature2,
          product_feature3:
            this.homePlanScenarios.data[0].attributes.home_plan.data.attributes.home_plan_translations.data[0]
              .attributes.product_feature3,
          product_feature4:
            this.homePlanScenarios.data[0].attributes.home_plan.data.attributes.home_plan_translations.data[0]
              .attributes.product_feature4,

          // insurer
          insurer_name_first:
            this.homePlanScenarios.data[0].attributes.home_plan.data.attributes.product.data.attributes
              .insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name,
          insurer_name_second:
            filteredTranslations[0].attributes.name,
          insurer_logo:
            this.homePlanScenarios.data[0].attributes.home_plan.data.attributes.product.data.attributes
              .insurance_company.data.attributes.logo,
          insurer_code:
            this.homePlanScenarios.data[0].attributes.home_plan.data.attributes.product.data.attributes
              .insurance_company.data.attributes.code,

          product_promotion: promotion,
          promotion_prices: promotionPrices,
          promotion_last_call: promotion_last_call,

          // discounted_ten_year_avg_premium: discountedTenYearAvgPremium,
          cta_button_link: CTAButtonLink,
          cta_button_text: CTAButtonText,

          main_cta: mainCTA,

          scenarioID: this.homePlanScenarios.data[0].id,

          // // ***** Home Terms *****
          home_term_values: this.homePlanScenarios.data[0].attributes.home_plan.data.attributes.home_term_values.data,
          home_coverage_values:
            this.homePlanScenarios.data[0].attributes.home_plan.data.attributes.home_coverage_values.data,
          hide,
          noPopup,
        };
      }
      return null;
    },
    product() {
      if (!this.simpleItems) return null;

      return {
        highlightSection: {
          scenarioId: this.simpleItems.scenarioId,
          showFiveStarBadge: this.$formatShowFiveStarBadge(this.simpleItems.overall_star),
          productName: this.simpleItems.plan_name,
          insuranceCompany: {
            name: this.simpleItems.insurer_name_first + ' | ' + this.simpleItems.insurer_name_second,
            code: this.simpleItems.insurer_code,
            logoSrc: this.simpleItems.insurer_logo?.data?.attributes?.url,
            logoAlt: this.simpleItems.insurer_name_first,
          },
          userRating: {
            // score: this.simpleItems.overall_star,
            numberOfRatedUser: '0',
          },
          tenlifeScore: {
            score: parseFloat(this.simpleItems.overall_score),
            description: this.$t('products.home.hm_overallScore'),
            toolTipHtml: this.getOverallScoreTooltip(this.simpleItems.owner),
          },
          features: [
            {
              text: this.getOwnerType(this.simpleItems.owner),
              type: 'owner_type',
            },
            {
              text: this.getPropertyType(this.simpleItems.property_type),
              type: 'property_type',
            },
            {
              text: this.$t('products.home.hm_buildingAgeFeature').replace(
                '{replace_age}',
                this.propertyAge || this.simpleItems.building_age_max
              ),
              type: 'property_age',
            },
            // {
            //   text: this.$t('products.home.hm_grossAreaFeature').replace(
            //     '{replace_range}',
            //     this.simpleItems.gross_area_min + '-' + this.simpleItems.gross_area_max
            //   ),
            //   type: 'property_gross_area',
            // },
            {
              text: this.$t('products.home.hm_saleableAreaFeature').replace(
                '{replace_range}',
                this.simpleItems.saleable_area_min + '-' + this.simpleItems.saleable_area_max
              ),
              type: 'property_gross_area',
            },
            {
              text: this.getPlanType(this.simpleItems.plan_type),
              type: 'plan_type',
            },
          ],
          keyItems: [
            {
              value: this.$formatScore(this.simpleItems.home_contents_score) + ' / 10',
              key: this.$t('products.home.hm_homeContentsScore'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('hm_homeContentsScore'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatScore(this.simpleItems.liability_score) + ' / 10',
              key: this.$t('products.home.hm_liabilityScore'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('hm_liabilityScore'),
              symbolValue: '',
              originalValue: '',
            },
            {
              value: this.$formatScore(this.simpleItems.personal_accident_score) + ' / 10',
              key: this.$t('products.home.hm_personalAccidentScore'),
              topSubText: '',
              toolTipHtml: this.getTooltipContentByKey('hm_personalAccidentScore'),
              symbolValue: '',
              originalValue: '',
            },
          ],
          mainButtonCTA: this.simpleItems.main_cta,
        },
        detailSection: {
          details: [
            {
              id: 0,
              sectionTitle: this.$t('products.home.hm_overview'),
              keyValues: [
                {
                  key: this.$t('products.home.hm_overallScore'),
                  value: this.$formatScore(this.simpleItems.overall_score) + ' / 10',
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.home.hm_hcMaximumProtection'),
                  value: this.$formatPrice(this.simpleItems.ch1040),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.home.hm_llMaximumProtection'),
                  value: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1010').value,
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.home.hm_paMaximumProtection'),
                  value: this.$formatSymbol(
                    this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CP1010').value
                  ),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.home.hm_firstYearPremium'),
                  value: this.simpleItems.promotion_prices[0]
                    ? this.$formatPrice(this.simpleItems.promotion_prices[0])
                    : this.$formatPrice(this.simpleItems.annual_premium),
                  originalValue: this.simpleItems.promotion_prices[0]
                    ? this.$formatPrice(this.simpleItems.annual_premium)
                    : '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.home.hm_propertyAgeMax'),
                  value:
                    this.simpleItems.building_age_max === 100
                      ? this.$t('products.home.hm_nolimit')
                      : this.$formatPrice(this.simpleItems.building_age_max),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.home.hm_propertyType'),
                  value: this.getMultiplePropertyType(this.simpleItems.multiple_property_type),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
              ],
            },
            {
              id: 1,
              sectionTitle: this.$t('products.home.hm_homeContents'),
              keyValues: [
                {
                  key: this.$t('products.home.hm_homeContentsScore'),
                  value: this.$formatScore(this.simpleItems.home_contents_score) + ' / 10',
                  keyToolTipHtml: this.getTooltipContentByKey('hm_homeContentsScore'),
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.home.hm_maximumCoverage'),
                  value: this.$formatPrice(this.simpleItems.ch1040),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.$t('products.home.hm_keyTypesOfHomeContentsCovered'),
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1051').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1051').value
                      ),
                    },
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1052').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1052').value
                      ),
                    },
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1054').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1054').value
                      ),
                    },
                    // {
                    //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1055').label,
                    //   value: this.$formatSymbol(
                    //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1055').value
                    //   ),
                    // },
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1056').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1056').value
                      ),
                    },
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1057').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1057').value
                      ),
                    },
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1058').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1058').value
                      ),
                    },
                    // {
                    //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1060').label,
                    //   value: this.$formatSymbol(
                    //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1060').value
                    //   ),
                    // },
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1061').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1061').value
                      ),
                    },
                    // {
                    //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1062').label,
                    //   value: this.$formatSymbol(
                    //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1062').value
                    //   ),
                    // },
                    // {
                    //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1068').label,
                    //   value: this.$formatSymbol(
                    //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1068').value
                    //   ),
                    // },
                    // {
                    //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1069').label,
                    //   value: this.$formatSymbol(
                    //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1069').value
                    //   ),
                    // },
                    // {
                    //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1070').label,
                    //   value: this.$formatSymbol(
                    //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1070').value
                    //   ),
                    // },
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1080').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1080').value
                      ),
                    },
                    // {
                    //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1100').label,
                    //   value: this.$formatSymbol(
                    //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1100').value
                    //   ),
                    // },
                  ],
                },
                {
                  // key: this.$t('products.home.hm_noAddLocCovered'),
                  key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1030').label,
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1032').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1032').value
                      ),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1034').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1034').value
                      ),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    // {
                    //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1036').label,
                    //   value: this.$formatSymbol(
                    //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1036').value
                    //   ),
                    //   keyToolTipHtml: '',
                    //   expandableKeyValues: [],
                    // },
                  ],
                },
                {
                  key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1020').label,
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1027').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1027').value
                      ),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    // {
                    //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1026').label,
                    //   value: this.$formatSymbol(
                    //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1026').value
                    //   ),
                    //   keyToolTipHtml: '',
                    //   expandableKeyValues: [],
                    // },
                    // {
                    //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1025').label,
                    //   value: this.$formatSymbol(
                    //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1025').value
                    //   ),
                    //   keyToolTipHtml: '',
                    //   expandableKeyValues: [],
                    // },
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1022').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1022').value
                      ),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1021').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1021').value
                      ),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.getHomeTerm(this.simpleItems.home_term_values, 'TH1024').label,
                      value: this.getHomeTerm(this.simpleItems.home_term_values, 'TH1024').value,
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    // {
                    //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1029').label,
                    //   value: this.$formatSymbol(
                    //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1029').value
                    //   ),
                    //   keyToolTipHtml: '',
                    //   expandableKeyValues: [],
                    // },
                  ],
                },
                // {
                //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1041').label,
                //   value: this.$formatSymbol(
                //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1041').value
                //   ),
                //   keyToolTipHtml: '',
                //   expandableKeyValues: [],
                // },

                {
                  key: this.$t('products.home.hm_limitPerItem'),
                  value: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1044').value,
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1110').label,
                  // value: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1110').value,
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    // {
                    //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1111').label,
                    //   value: this.$formatSymbol(
                    //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1111').value
                    //   ),
                    //   keyToolTipHtml: '',
                    //   expandableKeyValues: [],
                    // },
                    // {
                    //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1112').label,
                    //   value: this.$formatSymbol(
                    //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1112').value
                    //   ),
                    //   keyToolTipHtml: '',
                    //   expandableKeyValues: [],
                    // },
                    // {
                    //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1114').label,
                    //   value: this.$formatSymbol(
                    //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1114').value
                    //   ),
                    //   keyToolTipHtml: '',
                    //   expandableKeyValues: [],
                    // },
                    // {
                    //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1113').label,
                    //   value: this.$formatSymbol(
                    //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1113').value
                    //   ),
                    //   keyToolTipHtml: '',
                    //   expandableKeyValues: [],
                    // },
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1115').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1115').value
                      ),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1119').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1119').value
                      ),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1140').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1140').value
                      ),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                  ],
                },
                // {
                //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1131').label,
                //   value: this.$formatSymbol(
                //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CH1131').value
                //   ),
                //   keyToolTipHtml: '',
                //   expandableKeyValues: [
                //     {
                //       key: this.getHomeTerm(this.simpleItems.home_term_values, 'TH1132').label,
                //       value: this.$formatSymbol(this.getHomeTerm(this.simpleItems.home_term_values, 'TH1132').value),
                //       keyToolTipHtml: '',
                //       expandableKeyValues: [],
                //     },
                //   ],
                // },
                {
                  key: this.getHomeTerm(this.simpleItems.home_term_values, 'TH2000').label,
                  value: this.getHomeTerm(this.simpleItems.home_term_values, 'TH2000').value,
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.getHomeTerm(this.simpleItems.home_term_values, 'TH2010').label,
                  value: this.getHomeTerm(this.simpleItems.home_term_values, 'TH2010').value,
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
              ],
            },
            {
              id: 2,
              sectionTitle: this.$t('products.home.hm_legalLiabilities'),
              keyValues: [
                {
                  key: this.$t('products.home.hm_liabilityScore'),
                  value: this.$formatScore(this.simpleItems.liability_score) + ' / 10',
                  keyToolTipHtml: this.getTooltipContentByKey('hm_liabilityScore'),
                  expandableKeyValues: [],
                },
                {
                  key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1010').label,
                  value: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1010').value,
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                {
                  key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1030').label,
                  value: '',
                  keyToolTipHtml: '',
                  expandableKeyValues: [
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1021').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1021').value
                      ),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    // {
                    //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1031').label,
                    //   value: this.$formatSymbol(
                    //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1031').value
                    //   ),
                    //   keyToolTipHtml: '',
                    //   expandableKeyValues: [],
                    // },
                    // {
                    //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1032').label,
                    //   value: this.$formatSymbol(
                    //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1032').value
                    //   ),
                    //   keyToolTipHtml: '',
                    //   expandableKeyValues: [],
                    // },
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1033').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1033').value
                      ),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1034').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1034').value
                      ),
                      keyToolTipHtml: this.getTooltipContentByKey('hm_occupiersLiability'),
                      expandableKeyValues: [],
                    },
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1035').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1035').value
                      ),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                    // {
                    //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1036').label,
                    //   value: this.$formatSymbol(
                    //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1036').value
                    //   ),
                    //   keyToolTipHtml: '',
                    //   expandableKeyValues: [],
                    // },
                    {
                      key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1037').label,
                      value: this.$formatSymbol(
                        this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1037').value
                      ),
                      keyToolTipHtml: '',
                      expandableKeyValues: [],
                    },
                  ],
                },
                // {
                //   key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1040').label,
                //   value: this.$formatSymbol(
                //     this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CL1040').value
                //   ),
                //   keyToolTipHtml: '',
                //   expandableKeyValues: [],
                // },
              ],
            },
            {
              id: 3,
              sectionTitle: this.$t('products.home.hm_personalAccident'),
              keyValues: [
                {
                  key: this.$t('products.home.hm_personalAccidentScore'),
                  value: this.$formatScore(this.simpleItems.personal_accident_score) + ' / 10',
                  keyToolTipHtml: this.getTooltipContentByKey('hm_personalAccidentScore'),
                  expandableKeyValues: [],
                },
                {
                  key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CP1010').label,
                  value: this.$formatSymbol(
                    this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CP1010').value
                  ),
                  keyToolTipHtml: '',
                  expandableKeyValues: [],
                },
                // {
                //   key: this.$t('products.home.hm_severityInjuries'),
                //   value: '',
                //   keyToolTipHtml: '',
                //   expandableKeyValues: [
                //     {
                //       key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CP1021').label,
                //       value: this.$formatSymbol(
                //         this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CP1021').value
                //       ),
                //       keyToolTipHtml: '',
                //       expandableKeyValues: [],
                //     },
                //     {
                //       key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CP1022').label,
                //       value: this.$formatSymbol(
                //         this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CP1022').value
                //       ),
                //       keyToolTipHtml: '',
                //       expandableKeyValues: [],
                //     },
                //     {
                //       key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CP1023').label,
                //       value: this.$formatSymbol(
                //         this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CP1023').value
                //       ),
                //       keyToolTipHtml: '',
                //       expandableKeyValues: [],
                //     },
                //     {
                //       key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CP1024').label,
                //       value: this.$formatSymbol(
                //         this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CP1024').value
                //       ),
                //       keyToolTipHtml: '',
                //       expandableKeyValues: [],
                //     },
                //   ],
                // },
                // {
                //   key: this.$t('products.home.hm_causationAccidents'),
                //   value: '',
                //   keyToolTipHtml: '',
                //   expandableKeyValues: [
                //     {
                //       key: this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CP1011').label,
                //       value: this.$formatSymbol(
                //         this.getHomeCoverage(this.simpleItems.home_coverage_values, 'CP1013').value
                //       ),
                //       keyToolTipHtml: '',
                //       expandableKeyValues: [],
                //     },
                //   ],
                // },
              ],
            },
          ],
          promotion: {
            category:
              this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
                ?.PromotionCategory,
            title:
              this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
                ?.PromotionTitle,
            ctaButtonLink: this.simpleItems.cta_button_link,
            ctaButtonText: this.simpleItems.cta_button_text,
            promotionId: this.simpleItems.product_promotion?.id,
            scenarioId: this.simpleItems.scenarioId,
            hide: this.simpleItems.hide,
            noPopup: this.simpleItems.noPopup,
            lastCall: this.simpleItems.promotion_last_call

          },
        },
        // promotion: {
        //   category:
        //     this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
        //       ?.PromotionCategory,
        //   title:
        //     this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
        //       ?.PromotionTitle,
        //   ctaButtonLink:
        //     this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
        //       ?.CTAButtonLink,
        //   ctaButtonText:
        //     this.simpleItems.product_promotion?.attributes?.product_promotion_translations?.data[0].attributes
        //       ?.CTAButtonText,
        //   promotionId: this.simpleItems.product_promotion?.id,
        //   scenarioId: this.simpleItems.scenarioId,
        // },
      };
    },
  },

  methods: {
    getHomeTerm(terms, code) {
      let tmpTerm = null;
      let returnLabel = null;
      let returnValue = null;
      tmpTerm = terms.filter((term) => {
        return code === term.attributes.ht_code;
      });
      if (tmpTerm) {
        returnLabel =
          tmpTerm[0].attributes.home_term.data.attributes.home_term_translations.data[0].attributes.description;
        // numberic
        if (!isNaN(parseInt(tmpTerm[0].attributes.ht_value)) && isFinite(tmpTerm[0].attributes.ht_value)) {
          returnValue = this.$formatPrice(parseInt(tmpTerm[0].attributes.ht_value));
        }
        // boolean or else
        else {
          returnValue = tmpTerm[0].attributes.ht_value;
        }
        return {
          label: returnLabel,
          value: returnValue,
        };
      } else {
        return 'getHomeTerm not found';
      }
    },

    getHomeCoverage(coverages, code) {
      let tmpCoverage = null;
      let returnLabel = null;
      let returnValue = null;
      tmpCoverage = coverages.filter((cov) => {
        return code === cov.attributes.hc_code;
      });
      if (tmpCoverage) {
        returnLabel =
          tmpCoverage[0].attributes.home_coverage.data.attributes.home_coverage_translations.data[0].attributes
            .description;
        // numberic
        if (!isNaN(parseInt(tmpCoverage[0].attributes.hc_value))) {
          returnValue = this.$formatPrice(parseInt(tmpCoverage[0].attributes.hc_value));
        }
        // boolean or else
        else {
          returnValue = tmpCoverage[0].attributes.hc_value;
        }
        return {
          label: returnLabel,
          value: returnValue,
        };
      } else {
        return 'getHomeCoverage not found';
      }
    },

    getPropertyType(propertyType) {
      switch (propertyType) {
        case 'MB':
          return this.$t('products.home.hm_mb');
        case 'VH':
          return this.$t('products.home.hm_vh');
        case 'DH':
          return this.$t('products.home.hm_dh');
        case 'SDH':
          return this.$t('products.home.hm_sdh');
        default:
          return 'wrong property type';
      }
    },

    getMultiplePropertyType(multiplePropertyType) {
      const propertyTypes = multiplePropertyType.split('-');
      let result = '';
      propertyTypes.forEach((element, index) => {
        result += this.getPropertyType(element) + (index >= propertyTypes.length - 1 ? '' : ' / ');
      });
      return result;
    },

    getOwnerType(ownerType) {
      switch (ownerType) {
        case 'T':
          return this.$t('products.home.hm_tenant');
        case 'L':
          return this.$t('products.home.hm_landlord');
        case 'O':
          return this.$t('products.home.hm_owner');
        default:
          return 'wrong owner type';
      }
    },

    getPlanType(planType) {
      switch (planType) {
        case 'basic':
          return this.$t('products.home.hm_basic');
        default:
          return 'wrong plan type';
      }
    },

    getDecoderCTA(item, promotionCTALink) {
      const planName = item.attributes.home_plan.data.attributes.home_plan_translations.data[0].attributes.name;
      const insurer = item.attributes.home_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.insurance_company_translations.data[0].attributes.name;
      const decoderCTAWhatsappLink = this.$generateWhatsappCTALink(this.$t('products.home.hm_categoryName'), insurer, planName);
      const showCTA = item.attributes.show_cta;
      const saleable = item.attributes.home_plan.data.attributes.saleable;
      const productWebsite =
        item.attributes.home_plan.data.attributes.home_plan_translations.data[0].attributes.product_website;

      if (!showCTA) return null;

      if (saleable) {
        return {
          text: this.$t('products.purchase_now'),
          link:
            process.env.SALES_EXTERNAL_URL +
            '/' +
            (this.currentLocale === 'en' ? 'en' : 'tc') +
            '/purchase?id=' +
            item.attributes.scenario_code +
            '&ownerType=' +
            item.attributes.owner +
            '&propertyType=' +
            item.attributes.property_type +
            '&propertyAge=' +
            (this.propertyAge || item.attributes.building_age_max) +
            // '&grossArea=' +
            // (this.grossArea || item.attributes.gross_area_max) +
            '&saleableArea=' +
            (this.saleableArea || item.attributes.saleable_area_max),
        };
      } else if (promotionCTALink) {
        return {
          text: this.$t('products.purchase_now'),
          link: promotionCTALink,
        };
      } else if (productWebsite) {
        return {
          text: this.$t('products.product_website'),
          link: productWebsite,
          type: 'product-website',
        };
      } else {
        return {
          text: '',
          link: decoderCTAWhatsappLink,
        };
      }
    },

    getTooltipContentByKey(mKey) {
      return this.homeTooltips?.Home?.ToolTips?.find(({ Key }) => Key === mKey)?.ToolTipContent ?? '';
    },

    getOverallScoreTooltip(ownerType) {
      const tooltip = this.getTooltipContentByKey('hm_overallScore');
      let replaceHomeContentsScore = '';
      let replaceLiabilityScore = '';
      let replacePersonalAccidentScore = '';

      switch (ownerType) {
        case 'T':
          replaceHomeContentsScore = '65%';
          replaceLiabilityScore = '20%';
          replacePersonalAccidentScore = '15%';
          break;
        case 'L':
          replaceHomeContentsScore = '15%';
          replaceLiabilityScore = '80%';
          replacePersonalAccidentScore = '5%';
          break;
        default:
          replaceHomeContentsScore = '50%';
          replaceLiabilityScore = '40%';
          replacePersonalAccidentScore = '10%';
          break;
      }

      return tooltip
        .replace('{replace_home_contents_score}', replaceHomeContentsScore)
        .replace('{replace_liability_score}', replaceLiabilityScore)
        .replace('{replace_personal_accident_score}', replacePersonalAccidentScore);
    },
  },
};
